import React from 'react';
import { getGlobalTheme } from '@atlaskit/tokens';

const NotionIcon = () => {
	const { colorMode } = getGlobalTheme();
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_2574_18970)">
				<g clipPath="url(#clip1_2574_18970)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M4.49653 4.27103C5.23916 4.87439 5.51775 4.82836 6.91231 4.7353L20.0592 3.94589C20.3381 3.94589 20.1062 3.66772 20.0132 3.6215L17.8298 2.04305C17.4114 1.71824 16.8541 1.34626 15.7858 1.43932L3.05556 2.36781C2.59129 2.41385 2.49857 2.64598 2.68345 2.83204L4.49653 4.27103ZM5.28585 7.33493V21.1678C5.28585 21.9112 5.65735 22.1894 6.4935 22.1434L20.942 21.3073C21.7786 21.2613 21.8718 20.75 21.8718 20.1461V6.40601C21.8718 5.80308 21.6398 5.47793 21.1277 5.52434L6.0289 6.40601C5.47167 6.45284 5.2858 6.73157 5.2858 7.33493H5.28585ZM19.5494 8.07695C19.642 8.49514 19.5494 8.91296 19.1304 8.95998L18.4342 9.09869V19.311C17.8298 19.6359 17.2724 19.8216 16.808 19.8216C16.0644 19.8216 15.8781 19.5893 15.3211 18.8934L10.7675 11.7447V18.6613L12.2084 18.9864C12.2084 18.9864 12.2084 19.8216 11.0459 19.8216L7.84095 20.0075C7.74785 19.8216 7.84095 19.3578 8.16604 19.2649L9.00238 19.0331V9.88806L7.84118 9.795C7.74803 9.37681 7.97998 8.77383 8.63088 8.72705L12.069 8.49529L16.808 15.737V9.33078L15.5997 9.19212C15.507 8.68087 15.8781 8.30965 16.3428 8.26362L19.5494 8.07695ZM1.98671 1.11455L15.2282 0.139408C16.8542 -5.19529e-05 17.2726 0.0933756 18.2946 0.835771L22.5215 3.80662C23.2189 4.31749 23.4514 4.45657 23.4514 5.01347V21.3073C23.4514 22.3285 23.0794 22.9324 21.7788 23.0248L6.40148 23.9534C5.42517 23.9999 4.96052 23.8608 4.44923 23.2105L1.33652 19.172C0.778824 18.4285 0.546875 17.8724 0.546875 17.2217V2.73866C0.546875 1.90359 0.918988 1.20699 1.98671 1.11455Z"
						fill={colorMode === 'dark' ? 'white' : 'black'}
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_2574_18970">
					<rect width="24" height="24" fill={colorMode === 'dark' ? 'black' : 'white'} />
				</clipPath>
				<clipPath id="clip1_2574_18970">
					<rect width="24" height="24" fill={colorMode === 'dark' ? 'black' : 'white'} />
				</clipPath>
			</defs>
		</svg>
	);
};

export default NotionIcon;
